import {
  Table,
  Switch,
  Button,
  Spin,
  Tooltip,
  Space,
  Dropdown,
  Menu,
  Modal,
  Input,
  Typography
} from "antd";
import { selectUser } from "../../../redux/slices/user";
import { getColumnSearchProps } from "../../../utils/tables";
import Header from "../../../components/HeaderList";
import styles from "../styles/ProductsUI.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as MoreDetail } from "../../../assets/icons/more-detail.svg";
import PriceEditor from "./PriceEditor";

const { Text } = Typography;
const ProductsUI = (props) => {
  const {
    loading,
    products,
    handleProductActive,
    categories,
    confirmVisibility,
    visibleEditor,
    closeEditor,
    openEditor,
    importItems,
    syncModalVisible,
    setSyncModalVisible,
    isSyncing,
    lastSyncTime,
    syncOptions,
    setSyncOptions,
    handleSyncSubmit
  } = props;

  const user = useSelector(selectUser);

  const getCategoryName = (role) => {
    const index = categories.findIndex((el) => el.value === role);
    if (index > -1) {
      return categories[index].text;
    }
    return "-";
  };

  const irhacia = useNavigate();
  const goToCondiments = () => {
    irhacia("/productos/condiments");
  };
  const goToCategories = () => {
    irhacia("/productos/categorias");
  };
  const goToSuggets = () => {
    irhacia("/productos/recomendados");
  };

  const gotoProdSuc = () => {
    irhacia("/productos-por-sucursal");
  }

  const columns = [
    /* {
      title: "ID",
      dataIndex: "id",
      align: "center",
    }, */
    {
      title: "SKU",
      dataIndex: "sku",
      ...getColumnSearchProps("sku"),
    },
    {
      title: "Nombre",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Descripción",
      dataIndex: "description",
      width: 200,
      render: (val) => (
        <Tooltip placement="bottom" title={val}>
          <span className={styles.description}>{val}</span>
        </Tooltip>
      ),
    },
    {
      title: "Categoría",
      dataIndex: "id_category",
      align: "center",
      filters: categories,
      onFilter: (val, record) => record.id_category === val,
      render: (val) => getCategoryName(val),
    },
    {
      title: "Precio",
      dataIndex: "price",
      align: "center",
      render: (val) => `$${val.toFixed(2)}`,
    },
    {
      title: "Disponibilidad",
      align: "center",
      dataIndex: "take_out",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.take_out === value,
      render: (val, record) => (
        <Switch
          checked={val}
          onChange={() =>
            handleProductActive(record.id, val, "take_out", user.branch, user.id) // agregar id de usuario
          }
        />
      ),
    },
    /*  {
      title: "Eat In",
      align: "center",
      dataIndex: "eat_in",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.eat_in === value,
      render: (val, record) => (
        <Switch
          checked={val}
          onChange={() => handleProductActive(record.id, val, "eat_in", user.branch)}
        />
      ),
    }, */
  ];
  const options = (
    <Menu>
      <Menu.Item>Actualizar Imagen</Menu.Item>
      <Menu.Item onClick={openEditor}>Actualizar Precio</Menu.Item>
    </Menu>
  );
  const columnsAdmin = [
    {
      title: "SKU",
      dataIndex: "sku",
      ...getColumnSearchProps("sku"),
    },
    {
      title: "Nombre",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Categoría",
      dataIndex: "id_category",
      align: "center",
      filters: categories,
      onFilter: (val, record) => record.id_category === val,
      render: (val) => getCategoryName(val),
    },
    {
      title: "Precio",
      dataIndex: "price",
      align: "center",
      render: (val) => `$${val.toFixed(2)}`,
    },
    {
      title: "Dine In",
      align: "center",
      dataIndex: "eat_in",
      render: (active,record) => (
        <Switch checked={active} onChange={() => confirmVisibility(record.sku, "eat_in",active)} />
      ),
    },
    {
      title: "Take Out",
      align: "center",
      dataIndex: "take_out",
      render: (active,record) => (
        <Switch checked={active} onChange={() => confirmVisibility(record.sku, "take_out",active)} />
      ),
    },
    {
      title: "APP (Kiosco)",
      align: "center",
      dataIndex: "active_app",
      render: (active,record) => (
        <Switch checked={active} onChange={() => confirmVisibility(record.sku, "app",active)} />
      ),
    },
    /*
    {
      title: "WEB",
      align: "center",
      dataIndex: "active_web",
      render: (active,record) => (
        <Switch checked={active} onChange={() => confirmVisibility(record.sku, "web",active)} />
      ),
    },
    {
      title: "PEYA",
      align: "center",
      dataIndex: "active_peya",
      render: (active,record) => (
        <Switch checked={active} onChange={() => confirmVisibility(record.sku, "peya",active)} />
      ),
    },
    {
      title: "UBER",
      align: "center",
      dataIndex: "active_uber",
      render: (active,record) => (
        <Switch checked={active} onChange={() => confirmVisibility(record.sku, "uber",active)} />
      ),
    },
    {
      title: "Acciones",
      align: "center",
      dataIndex: "id",
      render: () => (
        <Dropdown overlay={options} className={styles.menu}>
          <MoreDetail />
        </Dropdown>
      ),
    }, */
  ];
  return (
    <div className={styles.view}>
      <Header title="Productos" />
      <div className={styles.buttons}>
        <Space style={{ paddingBottom: "1em" }}>
        <Button
            onClick={goToCategories}
            type="primary"
            size="large"
            className={styles.mainButton}
          >
            CATEGORÍAS
          </Button>
          <Button
            onClick={goToCondiments}
            type="primary"
            size="large"
            className={styles.mainButton}
          >
            CONDIMENTS
          </Button>
          <Button
            onClick={goToSuggets}
            type="primary"
            size="large"
            className="main-button"
          >
            RECOMENDADOS/SUGERIDOS
          </Button>
        </Space>
        {user.admin === 1 && (
          <div className={styles.actions}>
            <Button type="primary" size="large" className={styles.mainButton} onClick={gotoProdSuc}>Vista Sucursal</Button>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '10px' }}>
              <Button
                type="primary"
                size="large"
                className={styles.mainButton}
                onClick={() => setSyncModalVisible(true)}
                disabled={isSyncing}
              >
                {isSyncing ? "Sincronizando..." : "SINCRONIZAR"}
              </Button>
              {lastSyncTime && (
                <Text type="secondary" style={{ fontSize: '12px', marginTop: '4px' }}>
                  Última sincronización a las: {lastSyncTime}
                </Text>
              )}
            </div>
          {/*   <Button type="primary" size="large" className={styles.mainButton}>
              DISPONIBILIDAD
            </Button> */}
          </div>
        )}
      </div>

      <Modal
        title="Opciones de Sincronización"
        visible={syncModalVisible}
        onCancel={() => setSyncModalVisible(false)}
        onOk={handleSyncSubmit}
        okText="Iniciar Sincronización"
        cancelText="Cancelar"
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <Space align="center" style={{ justifyContent: 'space-between' }}>
            <Text strong>Categorías</Text>
            <Switch
              checked={syncOptions.categories}
              onChange={(val) => setSyncOptions({ ...syncOptions, categories: val })}
            />
          </Space>
          <Space align="center" style={{ justifyContent: 'space-between' }}>
            <Text strong>Productos</Text>
            <Switch
              checked={syncOptions.products}
              onChange={(val) => setSyncOptions({ ...syncOptions, products: val })}
            />
          </Space>
          <Space align="center" style={{ justifyContent: 'space-between' }}>
            <Text strong>Set Menus</Text>
            <Switch
              checked={syncOptions.setmenu}
              onChange={(val) => setSyncOptions({ ...syncOptions, setmenu: val })}
            />
          </Space>
          <Space align="center" style={{ justifyContent: 'space-between' }}>
            <Text strong>Condimentos</Text>
            <Switch
              checked={syncOptions.condiments}
              onChange={(val) => setSyncOptions({ ...syncOptions, condiments: val })}
            />
          </Space>

          <div style={{ marginTop: '10px' }}>
            <Text strong>SKU Específico (Opcional)</Text>
            <Input
              placeholder="Ej: 000000000000002484, 000000000000002485"
              value={syncOptions.sku}
              onChange={(e) => setSyncOptions({ ...syncOptions, sku: e.target.value })}
              style={{ marginTop: '5px' }}
            />
            <Text type="secondary" style={{ fontSize: '12px' }}>
              Si ingresas uno o varios SKUs (separados por coma), solo se sincronizarán esos elementos (incluyendo todas las coincidencias del mismo SKU), ahorrando mucho tiempo.
            </Text>
          </div>
        </div>
      </Modal>

      <Modal
        destroyOnClose
        wrapClassName={styles.modal}
        footer={false}
        visible={visibleEditor}
        width={300}
        closable={false}
        onCancel={closeEditor}
      >
        <PriceEditor closeEditor={closeEditor} />
      </Modal>
    
          <Table
            columns={user.admin === 1 ? columnsAdmin : columns}
            dataSource={products}
            rowKey="id"
            loading={loading}
          />
    </div>
  );
};

export default ProductsUI;
